import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { GameCollectStation, HuntingDistrict } from 'diwimamodelweb/lib';
import { deepCopy, removeUndefined } from 'diwimamodelweb/lib/utils/obejct-diff';
import { GameCollectStationService } from '../game-collect-station.service';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { GameCollectStationForm } from '../model/form';
import { UserFeedbackService } from '../user-feedback.service';
import { buildCustomDiff } from 'diwimamodelweb/lib/utils/obejct-diff';

@Component({
  selector: 'app-game-collect-station-form',
  templateUrl: './game-collect-station-form.component.html',
  styleUrls: ['./game-collect-station-form.component.css', '../../app.component.scss']
})
export class GameCollectStationFormComponent implements OnInit {
  [x: string]: any;

  @Input() data: GameCollectStationForm
  @Input() formBuilder: FormBuilder
  @Input() userFeedbackService: UserFeedbackService
  @Input() translateService: TranslateService
  @Input() objectService: GameCollectStationService
  // @ViewChild(InjectComponentDirective, {static: true}) view: InjectComponentDirective;

  
  gameCollectForm: FormGroup
  dropdownDataHuntingDistricts: HuntingDistrict[]

  isNew=false
  isCreate = false
  oldGameCollectStation: GameCollectStation

  constructor() { }

  ngOnInit(): void {
    if (!this.data.data){
      this.isCreate = true
      this.isNew=true
    } 
    this.dropdownDataHuntingDistricts = this.data.huntingDistricts
    this.gameCollectForm = this.formBuilder.group({
      name: [, Validators.required], 
      comment: [], 
      huntingDistrict: []
    })
    if(this.data.data) {
      this.isNew=false
      this.oldGameCollectStation = deepCopy(this.data.data)
      this.initilizeWithData()
    }
    this.gameCollectForm.valueChanges.subscribe(
      (value) => {
        if (!this.isCreate) {
          const {name, comment, huntingDistrict} = value
          let anyObj = {
            name, comment, 
            huntingDistrictId: huntingDistrict?.identifier,
            huntingDistrictName: huntingDistrict?.name,
            huntingDistrictAdministrativeName: huntingDistrict?.administrativeName
          }
          this.data.data.setFromAny(anyObj)
        }
      }
    )
    this.data.onNavBack = this.onCancle
  }

  initilizeWithData() {
    const {name, comment, huntingDistrictId} = this.data.data
    const district = this.data.huntingDistricts?.find(el => el.identifier == huntingDistrictId)
    this.gameCollectForm.patchValue({
      name, comment, huntingDistrict: district
    })

  }

  async onSubmit() {
    const {name, comment, huntingDistrict} = this.gameCollectForm.value
    if (this.isCreate) {
      // build new district
      const newGameCollectStation = {
        name, comment, 
        huntingDistrictId: huntingDistrict?.identifier,
        huntingDistrictName: huntingDistrict?.name,
        huntingDistrictAdministrativeName: huntingDistrict?.administrativeName
      }
      const cleaned = removeUndefined(newGameCollectStation)
      try {
        this.userFeedbackService.loading.emit(true)
        await this.objectService.createGameCollectStation(cleaned)
        this.userFeedbackService.loading.emit(false)
        const sbSuccessSave = await this.translateService.get('successfully_created').toPromise()
        this.userFeedbackService.showSnackBar.emit(sbSuccessSave)
        this.data.onCancle()
      } catch (error) {
        this.userFeedbackService.loading.emit(false)
        this.userFeedbackService.showDialog.emit(
          {
            entryComponent: GenericDialogComponent,
            title: "Error",
            message: error.error.message ? error.error.message : JSON.stringify(error),
          }
        )
      }
    } else {
      try {
        this.userFeedbackService.loading.emit(true)
        const newGameCollectStation = deepCopy(this.data.data, this.data.data.replacerFn)
        const sbSuccessSave = await this.translateService.get('changes_saved').toPromise() 
        await this.objectService.updateGameCollectStation(this.oldGameCollectStation, newGameCollectStation)
        this.userFeedbackService.loading.emit(false)
        this.userFeedbackService.showSnackBar.emit(sbSuccessSave)
        this.data.onCancle()
      } catch (error) {
        console.error(error)
        this.userFeedbackService.loading.emit(false)
        this.userFeedbackService.showDialog.emit(
          {
            entryComponent: GenericDialogComponent,
            title: "Error",
            message: error?.error?.message ? error?.error?.message : JSON.stringify(error),
          }
        )
      }
    }
  }

  onCancle = async () => {
    if (this.isCreate) {
      // this.data.onCancle()
      const title = await this.translateService.get('title_unsaved_changes').toPromise()
      const message = await this.translateService.get('msg_unsaved_changes').toPromise()
      this.userFeedbackService.showDialog.emit(
        {
          entryComponent: GenericDialogComponent,
          title,
          message,
          cancleCallback: async () => {
            //this gets the textvalue from en.json
            const sbChangesDismissed = await this.translateService.get('changes_dismissed').toPromise()
            this.userFeedbackService.showSnackBar.emit(sbChangesDismissed)
            this.data.onCancle()
          },
          positiveCallback: async ()=> {
            await this.onSubmit()
            this.data.onSuccessfullySubmitted()
          }
        }
      )
    } else {
      const newGameCollectStation = deepCopy(this.data.data, this.data.data.replacerFn)
      const diff = buildCustomDiff(this.oldGameCollectStation, newGameCollectStation)
      if (Object.keys(diff).length == 0) this.data.onCancle()
      else {
        const title = await this.translateService.get('title_unsaved_changes').toPromise()
        const message = await this.translateService.get('msg_unsaved_changes').toPromise()
        this.userFeedbackService.showDialog.emit(
          {
            entryComponent: GenericDialogComponent,
            title,
            message,
            cancleCallback: async () => {
              //this gets the textvalue from en.json
              const sbChangesDismissed = await this.translateService.get('changes_dismissed').toPromise()
              this.userFeedbackService.showSnackBar.emit(sbChangesDismissed)
              this.data.onCancle()
            },
            positiveCallback: async ()=> {
              await this.onSubmit()
              this.data.onSuccessfullySubmitted()
            }
          }
        )
      }
    }
  }
 
  async onDelete(){
    if(!this.isNew){
      const title = await this.translateService.get('delete_title').toPromise()
      const message = await this.translateService.get('delete_message').toPromise()  
      this.userFeedbackService.loading.emit(false)
      this.userFeedbackService.showDialog.emit(
        {
          entryComponent: GenericDialogComponent,
          title: title,
          message: message,
          cancleCallback: async ()=> {
            const sbCancelDelete = await this.translateService.get('delete_canceled').toPromise() 
            this.userFeedbackService.showSnackBar.emit(sbCancelDelete)

          },
          positiveCallback: async ()=>{
            try{
              this.userFeedbackService.loading.emit(true)
              const sbSuccessDelete = await this.translateService.get('delete_completed').toPromise() 
              this.objectService.deleteGameCollectStation(this.data.data)
              this.userFeedbackService.loading.emit(false)
              this.userFeedbackService.showSnackBar.emit(sbSuccessDelete)
              this.data.onCancle()
            }catch(errorDelete){
              console.log(errorDelete)
              const sbErrorDelete = await this.translateService.get('delete_error').toPromise() 
              this.userFeedbackService.showSnackBar.emit(sbErrorDelete)

            }
          } 
        }
      )
    }else{
      this.userFeedbackService.loading.emit(true)
      const sbSNoDelete = await this.translateService.get('delete_not_possible').toPromise() 
      this.userFeedbackService.showSnackBar.emit(sbSNoDelete)     
    }    
  }
}

